
import { z } from 'zod';

export const feedbackSchema = z.object({
  candidateName: z.string().min(2, "Le nom du candidat est requis"),
  candidateEmail: z.string().email("Email invalide").optional().or(z.literal('')),
  jobTitle: z.string().min(2, "L'intitulé du poste est requis"),
  positives: z.string().min(10, "Veuillez inclure au moins quelques points positifs"),
  improvements: z.string().min(10, "Veuillez inclure au moins quelques axes d'amélioration"),
  generalComment: z.string().optional(),
  finalMessage: z.string().optional(),
  certified: z.boolean().optional(),
  projectId: z.string().optional(),
});

export type FeedbackFormValues = z.infer<typeof feedbackSchema>;

export interface FeedbackFormProps {
  isRecruiter?: boolean;
  initialData?: {
    requestId?: string;
    candidateName?: string;
    candidateEmail?: string;
    jobTitle?: string;
    contextType?: string;
    directionType?: string;
    tableToUse?: string;
    title?: string;
    recruiterName?: string;
    recruiterCompany?: string;
    candidateUserId?: string;
    recruiterUserId?: string;
    projectId?: string;
  };
  onSubmitSuccess?: () => void;
  allowAccess?: boolean;
}
